import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught an error", error, info);
  }

  handleRetry = () => {
    window.location.assign("/");
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
            background: "#1A100C",
            color: "#F9F6EE",
            fontFamily: "'Inter', system-ui, sans-serif",
            textAlign: "center",
          }}
        >
          <h1 style={{ color: "#D4AF37", fontSize: "1.25rem", marginBottom: "12px" }}>
            Algo salió mal
          </h1>
          <p style={{ color: "#A89F91", fontSize: "0.9rem", maxWidth: "320px", lineHeight: 1.5 }}>
            La app encontró un error inesperado. Podés volver al inicio e intentar de nuevo.
          </p>
          <button
            type="button"
            onClick={this.handleRetry}
            style={{
              marginTop: "20px",
              padding: "10px 24px",
              borderRadius: "8px",
              border: "1px solid rgba(212,175,55,0.4)",
              background: "rgba(212,175,55,0.15)",
              color: "#D4AF37",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            Volver al inicio
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
